import React from 'react';
import { useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import 'rc-slider/assets/index.css';
import classNames from 'classnames';
import { validateRequired } from 'utils/form';
import { CustomSlider } from '../custom-slider';

import './range.styles.scss';
import { TimeCostSlider } from '../custom-slider/TimeCostSlider';
import { respondentDataSelector } from '../../../modules/survey/selectors';

interface RangeProps {
	id: number | string;
	name: string;
	required?: boolean;
	leftLabel: string;
	rightLabel: string;
	onChange?: (id: string | number, value: number) => void;
	defaultValue?: number | null;
	disabled?: boolean;
	wrapperClass?: string;
}

export const CustomRangeField = ({
	id,
	name,
	leftLabel,
	rightLabel,
	required,
	onChange,
	defaultValue,
	disabled,
	wrapperClass,
}: RangeProps) => {
	const { t } = useTranslation('errors');
	const { register, setValue, errors, triggerValidation } = useFormContext();

	// Begin kluge to customise based on Logo
	const respondentData = useSelector(respondentDataSelector);
	const logoUrl = respondentData?.logoFileUrl.toString();
	const logoWord = logoUrl?.substring(
		logoUrl.indexOf('/images/') + 8,
		logoUrl.indexOf('/images/') + 16,
	);

	// Kluge for college

	const isCollege =
		logoWord === 'c92b93da' ||
		logoWord === '57324ebc' || // prod
		logoWord === 'bcd72be7'; // the one in dev

	function handleChange(n: string, v: number) {
		setValue(n, v);
		triggerValidation(n);
	}

	function handleAfterChange(n: string, v: number) {
		if (onChange) {
			onChange(n, v);
		}
	}

	return (
		<div className={classNames('range', wrapperClass)}>
			{!isCollege && (
				<CustomSlider
					name={name}
					leftLabel={leftLabel}
					rightLabel={rightLabel}
					defaultValue={defaultValue}
					disabled={disabled}
					onChange={handleChange}
					onAfterChange={handleAfterChange}
				/>
			)}
			{isCollege && (
				<TimeCostSlider
					name={name}
					onChange={handleChange}
					defaultValue={defaultValue}
				/>
			)}
			<input
				ref={register({
					...validateRequired(required, t('required')),
				})}
				id={`${id}`}
				defaultValue={defaultValue ?? undefined}
				name={name}
				style={{
					height: 0,
					overflow: 'hidden',
					border: 'none',
					margin: 0,
					width: 0,
					padding: 0,
					position: 'absolute',
				}}
			/>
			<p
				className={`group__hint font-caption ${
					errors?.[name]?.message ? 'group__hint--error' : ''
				}`}
			>
				{errors?.[name]?.message}
			</p>
		</div>
	);
};
